export const REPORT_OPTION_TOOLTIPS = {
  private: 'Only you can see this report. Other users in the project cannot access it.',
  default: 'Shows this report under Workspace in the sidebar for everyone who can access the project.',
  favorite: 'Shows this report under My Favorites in your sidebar (only you).',
  removeFavorite: 'Removes this report from My Favorites in your sidebar.',
  none: 'Keep this report out of sidebar sections. Open it anytime from Reports Library.',
} as const;

export type ReportOptionKind = keyof typeof REPORT_OPTION_TOOLTIPS;

export const REPORT_OPTION_LABELS: Record<ReportOptionKind, string> = {
  private: 'Private',
  default: 'Workspace',
  favorite: 'My Favorites',
  removeFavorite: 'Remove from favorite',
  none: 'Reports Library',
};

/** All disabled-action hints for report menus, buttons, and creation flows. */
export const REPORT_ACTION_DISABLED_HINTS = {
  editOrder: "You don't have enough permissions to edit the chart order.",
  editReport: "You don't have enough permissions to edit this report.",
  deleteReport: "You don't have enough permissions to delete this report.",
  createTemplate: "You don't have enough permissions to create a template from this report.",
  duplicateReport: "You don't have enough permissions to duplicate this report.",
  publishToWorkspace: "You don't have enough permissions to publish this report to the workspace.",
  makePrivate: "You don't have enough permissions to make this report private.",
  createReport: "You don't have enough permissions to create reports.",
  createWorkspaceReport: "You don't have enough permissions to create workspace reports.",
  createReportDisabledSubproduct:
    'This workspace is not enabled yet. Switch to Experience to create reports, or contact sales to enable it.',

  reorderWorkspaceReports: 'Only admins can change the order of workspace reports, which is shared by everyone.',
  hideWorkspaceReports: 'Only admins can show or hide workspace reports, which is shared by everyone.',

  makePrivateOwnerOnly: 'You can only set as private the reports you created.',
  duplicatePrivateOwnerOnly: 'You can only duplicate the private reports you created.',
  favoritePrivateOwnerOnly: 'You can only favorite the private reports you created.',

  systemReportEditOrder: "System reports can't have their order edited.",
  systemReportEdit: "System reports can't be edited.",
  systemReportDelete: "System reports can't be deleted.",
  systemReportDuplicate: "System reports can't be duplicated.",
  systemReportPublishToWorkspace: "System reports can't be moved to the workspace.",
  systemReportMakePrivate: "System reports can't be set as private.",
  systemReportCreateTemplate: "System reports can't be used to create templates.",

  defaultWhenPrivate:
    'A private report cannot be the workspace default. Make the report public first, then you can set it as default.',
} as const;

/** Tooltips for UISwitcher rows in report creation / save flows. */
export const REPORT_CREATION_SWITCHER_TOOLTIPS = {
  accessWorkspace: 'All users in your Nebuly workspace who can access this project can open this report.',
  pinDefault: REPORT_OPTION_TOOLTIPS.default,
  pinFavorite: REPORT_OPTION_TOOLTIPS.favorite,
  pinPrivate: 'Keep this report private. You can still mark it as Favorite for quick access in your sidebar.',
  pinWorkspace: 'Keep this report available in the workspace. Workspace sidebar placement is managed by admins/owners.',
  pinUnpinned: REPORT_OPTION_TOOLTIPS.none,
} as const;
